import React from 'react';

const EotStaffPortfolio = () => {
  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe
        src="/projectList/eot-staff.html"
        title="Eka Portfolio App"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
     
    </div>
    
  );
}

export default EotStaffPortfolio;